import { AnyAction, Reducer } from 'redux';

export const STORE_USER_PROFILE = 'user/store-user-profile';
export const SELECT_USER_PROFILE = 'plan/select-user-profile';
export const STORE_CUSTOMERNAME = 'signupUser/store-customername';
export const STORE_CUSTOMERTYPE = 'signupUser/store-customertype';
export const STORE_CUSTOMERFIRSTNAME = 'signupUser/store-customerfirstname';
export const STORE_CUSTOMERLASTNAME = 'signupUser/store-customerlastname';
export const STORE_CUSTOMEREMAIL = 'signupUser/store-customeremail';
// export const STORE_CUSTOMERPHONENUMBER = 'signupUser/store-customerphonenumber';
export const STORE_CUSTOMERADDRESSONE = 'signupUser/store-customeraddressone';
export const STORE_CUSTOMERADDRESSTWO = 'signupUser/store-customeraddresstwo';
export const STORE_CUSTOMERCOUNTRY = 'signupUser/store-customercountry';
export const STORE_CUSTOMERSTATE = 'signupUser/store-customerstate';
export const STORE_CUSTOMERPRODUCT = 'signupUser/store-customerproduct';
export const STORE_CUSTOMERSCANNER = 'signupUser/store-customerscanner';
export const STORE_CUSTOMERCOMMAND = 'signupUser/store-customercommand';
export const STORE_CUSTOMERCITY = 'signupUser/store-customercity';
export const STORE_CUSTOMERZIPCODE = 'signupUser/store-customerzipcode';
export const STORE_CUSTOMERPOC = 'signupUser/store-customerpoc';
export const STORE_CUSTOMERPOCEMAIL = 'signupUser/store-customerpocemail';
export const STORE_CUSTOMERPOCPHONENUMBER = 'signupUser/store-customerpocphonenumber';
export const STORE_CUSTOMERPRODUCTPORTFOLIO = 'signupUser/store-customerproductportfolio';
export const STORE_CUSTOMERDESIGNSOFTWARE = 'signupUser/store-customerdesignsoftware';
export const STORE_CUSTOMERVERSIONOFSOFTWARE = 'signupUser/store-customerversionofsoftware';
export const STORE_CUSTOMERTURNAROUNDSERVICE = 'signupUser/store-customerturnaroundservice';
export const STORE_CUSTOMERPREFERENCEFORM = 'signupUser/store-customerpreferenceform';
export const STORE_CUSTOMERMATERIALFILES = 'signupUser/store-customermaterialfiles';
export const STORE_CUSTOMERPRICELIST = 'signupUser/store-customerpricelist';

export interface NewUser {
    transid: string;
    recid: string;
    custname: string;
    ctype: string;
    firsrname: string;
    lastname: string;
    emailid: string;
    phoneno: string;
    address1: string;
    address2: string;
    country: string;
    state: string;
    products: string;
    scanners: string;
    comments: string;
    city: string;
    zipcode: string;
    poc: string;
    pocemail: string;
    pocphonenumber: string;
    productportfolio: string;
    designsoftware: string;
    versionofsoftware: string;
    turnaroundservice: string;
    preferenceform: string;
    materialfiles: string;
    pricelist: string;
}

export interface SignupState {
    newUser?: NewUser;
    customername?: string;
    customertype?: string;
    customerfirstname?: string;
    customerlastname?: string;
    customeremail?: string;
    customerphonenumber?: string;
    customeraddressone?: string;
    customeraddresstwo?: string;
    customercountry?: string;
    customerstate?: string;
    customerproduct?: string;
    customerscanner?: string;
    customercommand?: string;
    customercity?: string;
    customerzipcode?: string;
    customerpoc?: string;
    customerpocemail?: string;
    customerpocphonenumber?: string;
    customerproductportfolio?: string;
    customerdesignsoftware?: string;
    customerversionofsoftware?: string;
    customerturnaroundservice?: string;
    customerpreferenceform?: File;
    customermaterialfiles?: File;
    customerpricelist?: string;
}

const initialState: SignupState = {
    newUser: {
        transid: '',
        recid: '',
        custname: '',
        ctype: '',
        firsrname: '',
        lastname: '',
        emailid: '',
        phoneno: '',
        address1: '',
        address2: '',
        country: '',
        state: '',
        products: '',
        scanners: '',
        comments: '',
        city: '',
        zipcode: '',
        poc: '',
        pocemail: '',
        pocphonenumber: '',
        productportfolio: '',
        designsoftware: '',
        versionofsoftware: '',
        turnaroundservice: '',
        preferenceform: '',
        materialfiles: '',
        pricelist: '',
    }
};

const reducer: Reducer<SignupState> = (state: SignupState = initialState, action: AnyAction): SignupState => {
    switch (action.type) {
        case STORE_CUSTOMERNAME:
            return {
                ...state,
                customername: action.customername
            };
        case STORE_CUSTOMERTYPE:
            return {
                ...state,
                customertype: action.customertype
            };
        case STORE_CUSTOMERFIRSTNAME:
            return {
                ...state,
                customerfirstname: action.customerfirstname
            };
        case STORE_CUSTOMERLASTNAME:
            return {
                ...state,
                customerlastname: action.customerlastname
            };
        case STORE_CUSTOMEREMAIL:
            return {
                ...state,
                customeremail: action.customeremail
            };
        // case STORE_CUSTOMERPHONENUMBER:
        //     return {
        //         ...state,
        //         customerphonenumber: action.customerphonenumber
        //     };
        case STORE_CUSTOMERADDRESSONE:
            return {
                ...state,
                customeraddressone: action.customeraddressone
            };
        case STORE_CUSTOMERADDRESSTWO:
            return {
                ...state,
                customeraddresstwo: action.customeraddresstwo
            };
        case STORE_CUSTOMERCOUNTRY:
            return {
                ...state,
                customercountry: action.customercountry
            };
        case STORE_CUSTOMERSTATE:
            return {
                ...state,
                customerstate: action.customerstate
            };
        case STORE_CUSTOMERPRODUCT:
            return {
                ...state,
                customerproduct: action.customerproduct
            };
        case STORE_CUSTOMERSCANNER:
            return {
                ...state,
                customerscanner: action.customerscanner
            };
        case STORE_CUSTOMERCOMMAND:
            return {
                ...state,
                customercommand: action.customercommand
            };
        case STORE_CUSTOMERCITY:
            return {
                ...state,
                customercity: action.customercity
            };
        case STORE_CUSTOMERZIPCODE:
            return {
                ...state,
                customerzipcode: action.customerzipcode
            };
        case STORE_CUSTOMERPOC:
            return {
                ...state,
                customerpoc: action.customerpoc
            };
        case STORE_CUSTOMERPOCEMAIL:
            return {
                ...state,
                customerpocemail: action.customerpocemail
            };
        case STORE_CUSTOMERPOCPHONENUMBER:
            return {
                ...state,
                customerpocphonenumber: action.customerpocphonenumber
            };
        case STORE_CUSTOMERPRODUCTPORTFOLIO:
            return {
                ...state,
                customerproductportfolio: action.customerproductportfolio
            };
        case STORE_CUSTOMERDESIGNSOFTWARE:
            return {
                ...state,
                customerdesignsoftware: action.customerdesignsoftware
            };
        case STORE_CUSTOMERVERSIONOFSOFTWARE:
            return {
                ...state,
                customerversionofsoftware: action.customerversionofsoftware
            };
        case STORE_CUSTOMERTURNAROUNDSERVICE:
            return {
                ...state,
                customerturnaroundservice: action.customerturnaroundservice
            };
        case STORE_CUSTOMERPREFERENCEFORM:
            return {
                ...state,
                customerpreferenceform: action.customerpreferenceform
            };
        case STORE_CUSTOMERMATERIALFILES:
            return {
                ...state,
                customermaterialfiles: action.customermaterialfiles
            };
        case STORE_CUSTOMERPRICELIST:
            return {
                ...state,
                customerpricelist: action.customerpricelist
            };
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/signupUser.tsx